import { CnCascaderSelect as UiCnCascaderSelect } from "../../components/cn-cascader-select";
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnCascaderSelect = connect(UiCnCascaderSelect, mapProps(mapSize, mapStatus, {
    dataSource: true,
}));
